'use client';

import { atom } from 'jotai';

import { FlagKey } from '@growthBookExperimentation/Entities/FlagKeys.entities';

export const pageviewExperimentAtom = atom(null as null | FlagKey[]);
